import PropTypes from "prop-types"
import React, { useState } from "react"
import BoatList from "src/main/Account/Boats/BoatList"
import EmptyStateImage from "src/main/Account/Boats/EmptyStateImage"
import NewBoatModal from "src/main/Account/Boats/NewBoatModal"

import Button from "src/components/Button"
import HeadingModalTitle from "src/components/Heading/HeadingModalTitle"
import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"

const Boats = ({ boats }) => {
  const [isNewBoatModalOpen, setIsNewBoatModalOpen] = useState(false)
  return (
    <div className="mt-10 flex flex-col pb-12">
      {boats.length > 0 ? (
        <>
          <div className="mb-8 flex items-center justify-between">
            <HeadingPageTitle>Boats</HeadingPageTitle>
            <Button
              onClick={() => setIsNewBoatModalOpen(true)}
              variant="primary"
            >
              Add New Boat
            </Button>
          </div>
          <div className="grid grid-cols-12 gap-8">
            <BoatList boats={boats} />
          </div>
        </>
      ) : (
        <div className="flex h-full items-center justify-center text-center lg:mt-12">
          <div className="flex w-full flex-col items-center justify-center space-y-4 lg:w-80">
            <EmptyStateImage />
            <div className="flex flex-col space-y-2">
              <HeadingModalTitle>No boats added yet</HeadingModalTitle>
              <span className="text-gray-600">
                Add your boat details for faster reservations and more efficient
                communication with marinas
              </span>
            </div>
            <Button
              onClick={() => setIsNewBoatModalOpen(true)}
              variant="primary"
            >
              Add New Boat
            </Button>
          </div>
        </div>
      )}
      <NewBoatModal
        isOpen={isNewBoatModalOpen}
        setIsOpen={setIsNewBoatModalOpen}
      />
    </div>
  )
}

Boats.propTypes = {
  boats: PropTypes.array.isRequired,
  incompleteBoatProfileProps: PropTypes.shape({
    details: PropTypes.array,
    insurance: PropTypes.array,
    registration: PropTypes.array,
    location: PropTypes.array,
    dimensions: PropTypes.array,
  }),
}

export default Boats
